<script lang="ts">
	import { onMount } from 'svelte';
	import type { ApplicationFormData } from './types';

	export let formData: ApplicationFormData;
	export let jobTitle: string;
	let heading: HTMLElement;
	onMount(() => {
    heading.scrollIntoView();
  });
</script>

<h4 bind:this={heading}>
	Thanks, {formData.name}!
</h4>
<p>
	Thanks for your interest in
	<strong>{jobTitle}</strong>. Your application has been received and you'll hear from Syntrio as
	soon as possible.
</p>
